import { GraphQLError } from "graphql";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { ApolloError } from "@apollo/client";
import * as Sentry from "@sentry/react";
import { useAppContext } from "../../context/app-context/AppContext";
import { ErrorFlag } from "../error-flag/ErrorFlag";
import { ErrorElementProps } from "./ErrorElement.Parts";

export const ErrorElement = ({ errorText }: ErrorElementProps) => {
  const error = useRouteError();
  const { appConfig } = useAppContext();

  const errorMessage =
    error instanceof ApolloError || error instanceof GraphQLError
      ? errorText?.[error.message]
      : isRouteErrorResponse(error)
        ? errorText?.["Error.NotFound"]
        : undefined;

  Sentry.captureException(error);
  if (!appConfig.production) console.error(error);

  return (
    <ErrorFlag
      customHeader={errorMessage?.header}
      customMessage={errorMessage?.message}
      showButton={errorMessage?.showButton}
    />
  );
};
